module.exports = __webpack_public_path__ + "static/media/6 0 tattoo chest eagle wingspan soaring detailed majestic.1280x2774.2fe7c8f9.webp";